import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import {
  useProcessDisbursementBatchMutation
} from '../../../../api-services/payments/paymentsApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { type BatchIdActionProps } from './DisbursementBatchPage'

const ProcessDisbursementBatch: React.FC<BatchIdActionProps> = ({ disbursementBatch }: BatchIdActionProps) => {
  const dispatch = useAppDispatch()

  const [apiProcessDisbursementBatchTrigger, apiProcessBatchResult] = useProcessDisbursementBatchMutation()
  const handleExportBatch = async (): Promise<void> => {
    await apiProcessDisbursementBatchTrigger(disbursementBatch.disbursementBatchId)
  }

  useEffect(() => {
    if (apiProcessBatchResult.isSuccess) {
      dispatch(setNotification({ open: true, severity: 'success', message: `Disbursement batch ${apiProcessBatchResult.data.disbursementBatchId} processed.` }))
    }

    if (apiProcessBatchResult.isError) {
      dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(apiProcessBatchResult.error) }))
    }
  }, [apiProcessBatchResult.isSuccess, apiProcessBatchResult.isError])

  return (
    <>
      <Button type={'button'} variant={'contained'} disabled={!disbursementBatch.processable} onClick={handleExportBatch}>
        Post to wallets
      </Button>
    </>
  )
}

export default ProcessDisbursementBatch
